import { FC } from 'react';
import { CellContainerProps } from './CellContainer.types';
import { Text } from '@/_components';
import styles from './CellContainer.module.css';
import { getClasses } from '@/_utils/classnames';

export const CellContainer: FC<CellContainerProps> = ({
  children,
  isActions,
  isHeader,
  text,
  width,
}) => {
  const cellContainerClasses: string = getClasses(styles.cellContainer, {
    [styles.cellContainerHeader]: isHeader,
    [styles.cellContainerActions]: isActions,
  });

  const cellStyle: object = {
    maxWidth: width ? `${width}px` : '100%',
    width: width ? `${width}px` : '100%',
  };

  return (
    <div style={cellStyle} className={cellContainerClasses}>
      {text ? (
        <Text
          type={isHeader ? 'small' : 'tiny'}
          lineClamp={2}
          fontWeight={isHeader ? 'medium' : undefined}
        >
          {text}
        </Text>
      ) : (
        children
      )}
    </div>
  );
};
